import { action, computed, makeAutoObservable, observable } from "mobx";
import RootStore from "stores/RootStore";

import UserAPI from "api/user";
import { publish } from "libs/pubsub";
import { getLayoutRoutes } from "src/routes";

export default class UserStore {
  rootStore: RootStore;

  userApi: UserAPI;

  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
    this.userApi = new UserAPI({ refreshToken: rootStore.refreshToken });
  }

  @observable initing = true;
  @observable loading = false;
  @observable userData = null;

  @action
  getProfile() {
    return new Promise((resolve, reject) => {
      if (this.userData) {
        resolve(this.userData);
        return;
      }

      this.userApi.getProfile()
        .then((res) => {
          this.userData = res;
          resolve(res);
        })
        .catch((err) => reject(err))
        .finally(() => {
          this.initing = false;
        });
    });
  }

  @action
  updateUser(payload) {
    return new Promise((resolve, reject) => {
      this.loading = true;
      this.userApi
        .updateUser(payload)
        .then((res) => {
          this.userData = { ...this.userData, ...payload };
          resolve(this.userData);
        })
        .catch((err) => reject(err))
        .finally(() => {
          this.loading = false;
        });
    });
  }

  @action
  changePassword(payload) {
    return new Promise((resolve, reject) => {
      this.loading = true;
      this.userApi
        .changePassword({
          username: this.rootStore.sessionInfo?.profile?.username,
          ...payload,
        })
        .then((res) => resolve(res))
        .catch((err) => reject(err))
        .finally(() => {
          this.loading = false;
        });
    });
  }

  @action
  verify(payload) {
    return new Promise((resolve, reject) => {
      this.loading = true;
      this.userApi
        .verify(this.rootStore.sessionInfo?.profile?.id, payload)
        .then((res) => {
          this.rootStore!.sessionInfo!.profile!.isemailconfirmed = '1';

          if (this.rootStore.layoutSubscriptionTopic) {
            publish(`${this.rootStore.layoutSubscriptionTopic}`, {
              routes: getLayoutRoutes(this.rootStore?.sessionInfo?.profile),
            });
          }

          resolve(res);
        })
        .catch((err) => reject(err))
        .finally(() => {
          this.loading = false;
        });
    });
  }
}
